<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M10 6L8.59 7.41 13.17 12 8.59 16.59 10 18 16 12z" transform="translate(-1440.000000, -2945.000000) translate(0.000000, 2872.000000) translate(1347.000000, 67.000000) translate(87.000000, 0.000000) translate(6.000000, 6.000000)"/>
</svg>
